import { useTranslation } from "react-i18next";
import { DsquaresLogo } from "src/assets/Icons";
import Version from "../Version/Version";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="w-full px-10 py-5">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <DsquaresLogo className="h-10 w-auto shrink-0" />

          <nav className="flex flex-wrap items-center gap-5">
            <a
              href="#"
              className="text-12 text-font-default transition-colors duration-150 hover:text-font-active"
            >
              {t("Menu.faqs")}
            </a>
            <a
              href="#"
              className="text-12 text-font-default transition-colors duration-150 hover:text-font-active"
            >
              {t("Menu.termsAndConditions")}
            </a>
            <a
              href="#"
              className="text-12 text-font-default transition-colors duration-150 hover:text-font-active"
            >
              {t("Menu.privacyPolicy")}
            </a>
            <Version />
          </nav>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-5 border-border-default pt-3">
          <span className="text-12 text-font-default">{t("Menu.copyright")}</span>

          <span className="text-12 flex items-center gap-1 text-font-default">
            {t("Menu.poweredBy")}
            <div className="font-semibold text-base text-font-active">Dsquares</div>
          </span>
        </div>
    </footer>
  );
}
